/** Tracks initialized xeokit BIM viewers (not merely mounted React wrappers). */
let activeIfcViewerCount = 0

const XEOKIT_OBJECT_KEYS_MESSAGE = "Cannot convert undefined or null to object"

export function registerIfcViewerMount(): () => void {
    activeIfcViewerCount += 1
    return () => {
        activeIfcViewerCount = Math.max(0, activeIfcViewerCount - 1)
    }
}

export function isIfcViewerActive(): boolean {
    return activeIfcViewerCount > 0
}

function isXeokitObjectKeysHighlightError(message: string, stack: string, filename: string): boolean {
    if (!message.includes(XEOKIT_OBJECT_KEYS_MESSAGE)) {
        return false
    }
    const source = `${filename}\n${stack}`
    return stack.includes("highlightedObjectIds") || stack.includes("Object.keys") || /xeokit|bim-viewer/i.test(source)
}

/** Errors from the xeokit BIM viewer must not trigger a full-page reload. */
export function isIfcViewerNonFatalGlobalError(event: ErrorEvent, ignoredMessageSubstrings: string[] = []): boolean {
    if (!event?.message) {
        return false
    }

    if (ignoredMessageSubstrings.some(substr => event.message.includes(substr))) {
        return true
    }

    const filename = event.filename ?? ""
    const stack = event.error instanceof Error ? (event.error.stack ?? "") : ""
    const source = `${filename}\n${stack}`

    if (/xeokit|bim-viewer/i.test(source)) {
        return true
    }

    if (stack.includes("highlightedObjectIds")) {
        return true
    }

    // Narrow fallback: only when xeokit is live and stack still hints at the known highlight bug.
    if (isIfcViewerActive() && isXeokitObjectKeysHighlightError(event.message, stack, filename)) {
        return true
    }

    return false
}

// Test-only reset
export function resetIfcViewerMountCountForTests(): void {
    activeIfcViewerCount = 0
}
